import React from 'react'
import searchIcon from '../../images/grey_mag.svg'

class SearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: ''};
    }

    handleChange = (event) => {
        let value = event.target.value;
        this.setState({value: value});
        if (this.props.onChange)
            this.props.onChange(value);
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.props.onSubmit)
            this.props.onSubmit(this.state.value);

    }

    render() {
        return (
            <div className="div-block-40">
                <div className="search-form search-formm">
                    <form className="search-form" onSubmit={this.handleSubmit}>
                        <input className="value-categories w-input" type="text" value={this.state.value} onChange={this.handleChange} placeholder={this.props.placeholder}/>
                    </form>
                    <button><img alt="" src={searchIcon} width="28" className="image-56"/></button>
                </div>
            </div>
        )
    }
}

export default SearchForm;
